<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
    </div>
    <el-card class="box-card" v-for="item in itemList" :key="item.ID">
      <div class="clearfix" :class="net===1 ? 'info' : 'danger'">
        <span style="color:white">{{item.PlatformName}}</span>
        <el-button
          style="float:right;margin-right:20px;color:white;"
          type="text"
          @click.stop="showStation(item)"
        >详情</el-button>
      </div>
      <div class="item">
        <div class="data-title">总计点位</div>
        <div class="data">{{item.StationsCount}}</div>
      </div>
      <div class="item">
        <div class="data-title">在线点位</div>
        <div class="data">{{item.OnlineCount}}</div>
      </div>
      <div class="item">
        <div class="data-title">离线点位</div>
        <div class="data">{{item.OfflineCount}}</div>
      </div>
      <div class="item">
        <div class="data-title">停运点位</div>
        <div class="data">{{item.StopCount}}</div>
      </div>
      <div class="item">
        <div class="data-title">说明</div>
        <div class="data">暂定</div>
      </div>
    </el-card>
  </el-card>
</template>

<script>
// import Point from "./point.vue";

export default {
  // components: {
  //   Point,
  // },
  data() {
    return {
      options: [
        {
          value: true,
          label: '是',
        },
        {
          value: false,
          label: '否',
        },
      ],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        ClientID: '',
        'PlatformName|ContractNumber:like': '',
        ProtectStatus: '',
        BelongID: 50,
      },
      ifprotect: '',
      item: this.getEmptyItem(),
      itemVisible: false,
      net: 1,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get('platformhomepage/ipc', {
          params: {
            where: this.form,
            // with: ['Client'],
            ...this.pager,
            ifprotect: this.ifprotect,
            contractnumber: this.contractnumber,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    showStation(item) {
      // this.$router.push({ path: `platformstation`, params: { item } });
      
      this.$router.push(`platformstation?name=${item.PlatformName}&id=${item.ID}`);
    },
    getEmptyItem() {
      return {};
    },
  },
};
</script>
<style scope>
.box-card {
  margin-bottom: 20px;
}
.item {
  width: 17%;
  float: left;
  text-align: center;
  margin-bottom: 0;
}
.data-title {
  margin-bottom: 5px;
  color: #909399;
}
.data {
  margin-bottom: 10px;
}
</style>
